let moment = require('moment');
let momentDurationFormatSetup = require("moment-duration-format");
momentDurationFormatSetup(moment);

export function getFormattedDateTime(date = new Date()) {
  return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${padLeadingZero(date.getMinutes())}:${padLeadingZero(date.getSeconds())}`;
}

export function getLocalFormattedDateTime(date = new Date()) {
  return `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}T${date.getHours()}:${padLeadingZero(date.getMinutes())}:${padLeadingZero(date.getSeconds())}Z`;
}
export function getDateString(date){
  return moment(date).format('YYYY-MM-DDTHH:mm:ss');

}

export function padLeadingZero(value) {
  return value > 9 ? value : `0${value}`;
}

export function getMonthName(month) {
  return moment().month(month).format('MMM');
}
export function getDate(year,month){
  let startDate= moment([year, month - 1]);
  let endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');
  return endDate;
}

export function getCCExpireDate(year,month){
  let startDate= moment([year, month]);
  let endDate = moment(startDate).endOf('month').format('MM/YYYY');
  return endDate;
}
export function convertCCExpireDate(dateString){
  return moment('01/'+dateString,'DD/MM/YYYY');
}

export function getTimeBetweenDates(start, end) {
  if (start === end) {
    return null;
  }
  let duration = moment.duration(moment(end).diff(moment(start)), "ms");
  let formatTemplate = duration >= 86400000 ? "w [weeks], d [days]" : "HH:mm:ss";
  return duration.format(formatTemplate, {
    trim: false
  });
}

export function clearDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
}

export function getDayOfWeek(num){
  return moment().isoWeekday(num).format('dddd');
}

export function getEndDateFromStartDateAndDurationUnit(start,duration,durationUnit){
  return moment(start).add(duration,durationUnit);
}

export function getTimeDifference(start,end){
  let diff = moment(end).diff(moment(start));
  let duration = moment.duration(diff);
  let hours=duration.asHours();
  return Math.round(hours);
}

export function shouldDisableDate(availableDates,date){
  let dayOfWeek=date.getDay();
  return availableDates.filter(s=>s==dayOfWeek);
}

export function getDatetimeFromTime(time){
  let date=new Date();
  date.setDate(date.getDate());
  let string=`${moment(date).format("YYYY-MM-DD")}T${time}`;
  return new Date(string);
}



// WEBPACK FOOTER //
// ./src/utils/dates.js